import { useEffect, useState } from 'react'

import styles from './style.module.css'
import { useJobSearch } from '@src/state/jobSearch'
import SearchInput from '@components/SearchInput'
import LocationInput from '@components/LocationInput'

export default function SearchNav({ Logo, RightContents }) {
  const { state, dispatch } = useJobSearch()
  const [searchTerm, setSearchTerm] = useState(state?.searchTerm)
  const [location, setLocation] = useState(state?.location)

  const handleSearch = (val) => {
    setSearchTerm(val)
  }

  const handleLocationChange = (location) => {
    dispatch({
      type: 'updateLocation',
      payload: { ...location },
    })
    setLocation(location)
  }

  useEffect(() => {
    setSearchTerm(state?.searchTerm)
    setLocation(state?.location)
  }, [state?.searchTerm, state?.location])

  const searchUrl = '';
  const canSearch =
    searchTerm &&
    (state?.location?.formatted_address || location?.formatted_address)

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <Logo />
      </div>
      <div className={styles.searchContainer}>
        <SearchInput
          updateAfterClick
          value={state.searchTerm}
          canSearch={canSearch}
          onUpdate={handleSearch}
          searchUrl={searchUrl}
          height={48}
        />
        <LocationInput
          defaultValue={state?.location}
          handleChange={handleLocationChange}
          nav
        />
      </div>
      <div className={styles.rightContainer}>
        <RightContents />
      </div>
    </div>
  )
}
